import createDataSelectorDefinition from './create-data.js'
import getDataSelectorDefinition from './get-data.js'
import dataSelectorDefinition from './data.js'

const kycSelectors = [
  //
  createDataSelectorDefinition,
  getDataSelectorDefinition,
  dataSelectorDefinition,
]

export default kycSelectors
